import { useLocation } from "react-router";

import AboutPage from "@/app/AboutPage";
import AuthenticatedApp from "@/app/AuthenticatedApp";
import { useAuth } from "@/app/providers/AuthProvider";
import { ROUTES } from "@/app/routes";
import UnauthenticatedApp from "@/app/UnauthenticatedApp";
import { Loader } from "@/components/common/Loader";

export default function App() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Answered before the session check, so a deploy can be identified even when
  // the API is unreachable.
  if (location.pathname === ROUTES.about) {
    return <AboutPage />;
  }

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-muted">
        <Loader />
      </div>
    );
  }

  return isAuthenticated ? <AuthenticatedApp /> : <UnauthenticatedApp />;
}
